.input,
.radio {
  cursor: pointer;

  &:not([disabled]) {
    &:active {
      outline: var(--mantine-spacing-xs) solid var(--mantine-color-primary-light);
    }
  }
}

.label {
  /* font-family: 'Serif-Font', serif; */
  font-size: var(--mantine-font-size-md);
}
